import { Carousel } from "antd";
import React, { useRef } from "react";
import { BsArrowLeftShort, BsArrowRightShort } from "react-icons/bs";
import { Link } from "react-router-dom";
import styles from "./BetaSlider.module.scss";

const BetaSlider = ({ slides, title, link, item_count }) => {
    const slider = useRef(null);
    return (
        <div className={styles.wrapper + " container"}>
            <div className={"see_more_title"} style={{ margin: "var(--mb-mg)" }}>
                <h2>{title}</h2>
                {link && (
                    <Link to={link} className={styles.view_all + " mb_only"}>
                        <span>See More</span>
                        <BsArrowRightShort size={20} />
                    </Link>
                )}
                <div className={"dt_only " + styles.dt_nav}>
                    {link && (
                        <Link to={link} className={styles.view_all}>
                            <span>See More</span>
                        </Link>
                    )}
                    <BsArrowLeftShort
                        size={25}
                        onClick={() => {
                            slider.current.prev();
                        }}
                    />
                    <BsArrowRightShort
                        size={25}
                        onClick={() => {
                            slider.current.next();
                        }}
                    />
                </div>
            </div>
            <Carousel
                dots={false}
                draggable={false}
                slidesToShow={window.innerWidth > 577 ? (item_count ? item_count : 4) : 1}
                ref={slider}
            >
                {slides.map((slide, index) => {
                    return (
                        <Link to={slide.url} key={index}>
                            <div className={styles.item}>
                                <img loading="lazy" decoding="async" src={slide.img} alt="" />
                            </div>
                        </Link>
                    );
                })}
            </Carousel>
        </div>
    );
};

export default BetaSlider;
